/* AA PDP — compléments (test_benjo).
   - titre : la partie après « — » passe en sous-titre (même texte, affichage seulement)
   - titres de modules : retire émojis et « + » de tête
   - bande de chiffres clés : affichée seulement à partir de 3 chiffres
   - FAQ : tous les anciens formats ramenés au même accordéon (fermé par défaut)
   - bloc cadeau + cartes de liens réunis en un seul encart « cadeau & à associer » */
(function () {
  'use strict';
  var LEAD = /^[\s +&]*(?:(?:[☀-➿️‍]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDC00-\uDFFF])[\s +&]*)+/;

  function splitTitle() {
    var h = document.querySelector('.product-single__title');
    if (!h || h.querySelector('.aa-subtitle') || h.children.length) return;
    var t = h.textContent.replace(/\s+/g, ' ').trim();
    var m = t.match(/^(.{6,}?)\s+[—–]\s+(.{6,})$/);
    if (!m) return;
    h.textContent = '';
    h.appendChild(document.createTextNode(m[1]));
    var sep = document.createElement('span');
    sep.className = 'aa-subtitle__sep';
    sep.textContent = ' — ';
    h.appendChild(sep);
    var sub = document.createElement('span');
    sub.className = 'aa-subtitle';
    sub.textContent = m[2];
    h.appendChild(sub);
  }

  function cleanHeads() {
    document.querySelectorAll('.aa-pc h2, .aa-pc h3, .aa-pc h4').forEach(function (el) {
      var n = el.firstChild;
      while (n && n.nodeType !== 3) n = n.firstChild;
      if (n && LEAD.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(LEAD, '');
    });
  }

  function figs() {
    document.querySelectorAll('.aa-pc .aa-figs').forEach(function (b) {
      if (b.children.length < 3) b.remove();
    });
  }


  function faqs() {
    var root = document.querySelector('.aa-pc');
    if (!root) return;
    var ITEM = /faq[-_]?item|faq__item|faq-row|faq-entry/i;
    // Ancien format en div : question + réponse
    root.querySelectorAll('[class*="faq-q"], [class*="faq-question"], [class*="faq__q"]').forEach(function (q) {
      if (q.closest('details') || q.tagName === 'SUMMARY' || q.tagName === 'DETAILS') return;
      var a = q.nextElementSibling;
      if (!a) return;
      var item = q.parentElement;
      var wrapped = item && item !== root && ITEM.test(item.className || '');
      var d = document.createElement('details');
      var s = document.createElement('summary');
      while (q.firstChild) s.appendChild(q.firstChild);
      var ans = document.createElement('div');
      ans.className = 'aa-a';
      if (wrapped) {
        var n = q.nextSibling;
        while (n) { var nx = n.nextSibling; ans.appendChild(n); n = nx; }
      } else {
        ans.appendChild(a);
      }
      d.appendChild(s);
      d.appendChild(ans);
      if (wrapped) item.parentNode.replaceChild(d, item);
      else q.parentNode.replaceChild(d, q);
    });
    // Tous les accordéons : même classe, fermés, réponse dans .aa-a
    root.querySelectorAll('details').forEach(function (d) {
      var s = d.querySelector(':scope > summary');
      if (!s) return;
      d.className = 'aa-q';
      d.removeAttribute('open');
      d.removeAttribute('style');
      s.removeAttribute('style');
      s.removeAttribute('class');
      var rest = Array.prototype.filter.call(d.childNodes, function (n) { return n !== s && (n.nodeType === 1 || (n.nodeType === 3 && n.nodeValue.trim())); });
      if (rest.length === 1 && rest[0].nodeType === 1 && rest[0].tagName === 'DIV') {
        rest[0].className = 'aa-a';
        rest[0].removeAttribute('style');
      } else if (rest.length) {
        var ans = document.createElement('div');
        ans.className = 'aa-a';
        rest.forEach(function (n) { ans.appendChild(n); });
        d.appendChild(ans);
      }
      var n = s.firstChild;
      while (n && n.nodeType !== 3) n = n.firstChild;
      if (n && LEAD.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(LEAD, '');
      if (d.parentElement) d.parentElement.classList.add('aa-faqn');
    });
  }

  function secHeads() {
    var rte = document.querySelector('.aa-pc .aa-body') || document.querySelector('.aa-pc .rte');
    if (!rte) return;
    var SKIP = 'details, table, a, .aa-gl, .aa-gift, .aa-mat, .aa-des, .aa-steps, [class*="gift"], [class*="cadeau"], [class*="box"], [class*="card"], [class*="design"], [class*="story"]';
    rte.querySelectorAll('h2, h3').forEach(function (h) {
      if (h.classList.contains('aa-title') || h.classList.contains('aa-gl__h')) return;
      var par = h.parentElement;
      if (!par || (par !== rte && par.closest(SKIP))) return;
      var sibs = Array.prototype.filter.call(par.children, function (c) { return /^H[23]$/.test(c.tagName); });
      if (sibs.length < 2) return;
      h.classList.add('aa-sec-h');
      h.removeAttribute('style');
    });
  }

  function giftLinks() {
    var root = document.querySelector('.aa-pc');
    if (!root || root.querySelector('.aa-gl')) return;
    var gift = root.querySelector('.aa-gift, .fp-gift, [class*="gift"]:not(a):not(.aa-gl)');
    var first = root.querySelector('a.aa-link, a.aa-link-card, a.fp-link-card, a.lc-card');
    var links = first && first.parentElement;
    if (gift) {
      var t0 = gift.firstChild;
      while (t0 && t0.nodeType === 3 && !t0.nodeValue.trim()) t0 = t0.nextSibling;
      if (t0 && t0.nodeType === 3) t0.nodeValue = t0.nodeValue.replace(LEAD, '');
    }
    if (!gift || !links || links.contains(gift) || gift.contains(links)) return;
    var head = links.previousElementSibling;
    if (!(head && /^H[2-4]$/.test(head.tagName))) head = null;
    var wrap = document.createElement('section');
    wrap.className = 'aa-gl';
    var anchor = (gift.compareDocumentPosition(links) & Node.DOCUMENT_POSITION_FOLLOWING) ? gift : (head || links);
    anchor.parentNode.insertBefore(wrap, anchor);
    var g = document.createElement('div');
    g.className = 'aa-gl__gift';
    while (gift.firstChild) g.appendChild(gift.firstChild);
    var n = g.firstChild;
    while (n && n.nodeType === 3 && !n.nodeValue.trim()) n = n.nextSibling;
    if (n && n.nodeType === 3) n.nodeValue = n.nodeValue.replace(LEAD, '');
    gift.remove();
    wrap.appendChild(g);
    var l = document.createElement('div');
    l.className = 'aa-gl__links';
    if (head) { head.className = (head.className + ' aa-gl__h').trim(); head.removeAttribute('style'); l.appendChild(head); }
    var list = document.createElement('div');
    list.className = 'aa-gl__list';
    Array.prototype.slice.call(links.querySelectorAll('a')).forEach(function (a) {
      a.classList.add('aa-gl__a');
      a.querySelectorAll('.lc-icon, .ic').forEach(function (i) { i.remove(); });
      list.appendChild(a);
    });
    l.appendChild(list);
    wrap.appendChild(l);
    if (!links.children.length && !links.textContent.trim()) links.remove();
  }

  function run() {
    [splitTitle, cleanHeads, figs, faqs, giftLinks, secHeads].forEach(function (f) { try { f(); } catch (e) {} });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* ==== BBL début modif — bloc « Versions disponibles » en liste (option B) ==== */
(function () {
  function versionsList() {
    document.querySelectorAll('.aa-pc .aa .aa-ben').forEach(function (box) {
      if (box.classList.contains('aa-ben--list')) return;
      var cards = Array.prototype.filter.call(box.children, function (c) { return c.classList.contains('aa-b'); });
      if (!cards.length) return;
      var withDash = cards.filter(function (c) { var t = c.querySelector('.tt'); return t && t.textContent.indexOf(' — ') > -1; }).length;
      if (withDash < Math.ceil(cards.length / 2)) return;
      box.classList.add('aa-ben--list');
      cards.forEach(function (c) {
        var t = c.querySelector('.tt'); if (!t) return;
        var txt = t.textContent, i = txt.indexOf(' — '); if (i < 0) return;
        var name = txt.slice(0, i).trim(), sub = txt.slice(i + 3).trim();
        t.textContent = name;
        var redundant = sub.toLowerCase().indexOf(name.toLowerCase()) > -1 && sub.split(/\s+/).length <= 3;
        if (sub && !redundant) { var s = document.createElement('span'); s.className = 'aa-ben__sub'; s.textContent = sub; t.insertAdjacentElement('afterend', s); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', versionsList);
  else versionsList();
})();
/* ==== BBL fin modif ==== */

/* ==== BBL début modif — bloc « Versions disponibles » en liste (option B) ==== */
(function () {
  var DASH = /\s[—–]\s/;
  function versionsList() {
    document.querySelectorAll('.aa-pc .aa .aa-ben').forEach(function (box) {
      if (box.classList.contains('aa-ben--list')) return;
      var cards = Array.prototype.filter.call(box.children, function (c) { return c.classList.contains('aa-b'); });
      if (!cards.length) return;
      var withDash = cards.filter(function (c) { var t = c.querySelector('.tt'); return t && DASH.test(t.textContent); }).length;
      if (withDash < Math.ceil(cards.length / 2)) return;
      box.classList.add('aa-ben--list');
      cards.forEach(function (c) {
        var t = c.querySelector('.tt'); if (!t) return;
        var txt = t.textContent.replace(/\s+/g, ' ').trim();
        var m = txt.match(DASH); if (!m) return;
        var name = txt.slice(0, m.index).trim(), sub = txt.slice(m.index + m[0].length).trim();
        t.textContent = name;
        var redundant = sub.toLowerCase().indexOf(name.toLowerCase()) > -1 && sub.split(/\s+/).length <= 3;
        if (sub && !redundant) { var s = document.createElement('span'); s.className = 'aa-ben__sub'; s.textContent = sub; t.insertAdjacentElement('afterend', s); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', versionsList);
  else versionsList();
})();
/* ==== BBL fin modif ==== */
/* ==== BBL début modif — début de « Tout savoir » sous les photos (ordinateur) ====
   Sur ordinateur (980 px et plus) : le surtitre « Tout savoir », le sommaire et le paragraphe d'introduction
   sont affichés sous les photos, dans la colonne de gauche. Le reste de la description reste en pleine largeur.
   Si la colonne d'achat reste nettement plus haute, le bloc « Dans la boîte » passe aussi sous l'introduction, à gauche.
   Sur mobile : tout reste à sa place d'origine, après le bloc d'achat. La grille de photos supplémentaires n'est plus utilisée. */
(function () {
  var mq = window.matchMedia('(min-width: 980px)');
  var pc, head, headHome, intro, introHome, side, sideInner, boxBlock, boxHome;
  function contentHeight(el) {
    var h = 0;
    Array.prototype.forEach.call(el.children, function (c) { if (!/^(SCRIPT|STYLE|LINK)$/.test(c.tagName)) h += c.offsetHeight; });
    return h;
  }
  function balance(media) {
    var box = document.querySelector('.section--product-single .product-single__box');
    if (!boxBlock) {
      var b = box && box.querySelector('.aa-box');
      if (!b) return;
      boxBlock = b.closest('.product-single__box__block') || b;
      boxHome = document.createComment('aa-box-home');
      boxBlock.parentNode.insertBefore(boxHome, boxBlock);
    }
    if (!mq.matches) {
      if (boxBlock.parentNode === side) boxHome.parentNode.insertBefore(boxBlock, boxHome.nextSibling);
      boxBlock.classList.remove('aa-box--side');
      return;
    }
    if (boxBlock.parentNode === side || !box) return;
    if (box.offsetHeight - contentHeight(media) > 60) {
      side.appendChild(boxBlock);
      boxBlock.classList.add('aa-box--side');
    }
  }
  function setup() {
    if (side) return true;
    pc = document.getElementById('aa-description');
    if (!pc) return false;
    head = pc.querySelector('.aa-pc__head');
    var body = pc.querySelector('.aa-pc__body');
    if (!head || !body) return false;
    var inner = body.querySelector(':scope > .aa, :scope > .aa-body') || body;
    var first = null;
    for (var i = 0; i < inner.children.length; i++) {
      var c = inner.children[i];
      if (/^(STYLE|SCRIPT|LINK|META)$/.test(c.tagName)) continue;
      first = c; break;
    }
    if (first && first.tagName === 'P') intro = first;
    side = document.createElement('div');
    side.className = 'aa-pc-side';
    var sideBody = document.createElement('div');
    sideBody.className = body.className;
    side.appendChild(sideBody);
    sideInner = sideBody;
    if (inner !== body) { sideInner = document.createElement('div'); sideInner.className = inner.className; sideBody.appendChild(sideInner); }
    headHome = document.createComment('aa-pc-head-home');
    head.parentNode.insertBefore(headHome, head);
    if (intro) {
      introHome = document.createElement('p');
      introHome.className = 'aa-intro-home';
      introHome.hidden = true;
      intro.parentNode.insertBefore(introHome, intro);
    }
    return true;
  }
  function place() {
    document.querySelectorAll('.section--product-single .aa-gallery-more').forEach(function (g) { g.remove(); });
    var media = document.querySelector('.section--product-single .product-single__media');
    if (!media || !setup()) return;
    if (mq.matches) {
      side.insertBefore(head, side.firstChild);
      if (intro) sideInner.appendChild(intro);
      if (side.parentNode !== media) media.appendChild(side);
      media.classList.add('aa-has-side');
      pc.classList.add('aa-pc--split');
    } else {
      headHome.parentNode.insertBefore(head, headHome.nextSibling);
      if (intro) introHome.parentNode.insertBefore(intro, introHome);
      if (side.parentNode) side.parentNode.removeChild(side);
      media.classList.remove('aa-has-side');
      pc.classList.remove('aa-pc--split');
    }
    if (document.readyState === 'complete') balance(media);
  }
  function start() {
    place();
    if (mq.addEventListener) mq.addEventListener('change', place);
    else if (mq.addListener) mq.addListener(place);
    window.addEventListener('load', function () { setTimeout(place, 50); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* ==== BBL fin modif ==== */